import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from '../../../redux/connect';
import {
  getCurrentPreviewIssueAttributes,
  getCurrentViewType,
} from '../../../redux/selectors';
import T from 'i18n-react';
import { ButtonGroup } from '@adsk/bim360-matrix-react-components';
import { getCallToActionOptions } from '../../../utils/transition-helpers';
import { issueAttributesType } from '../../../constants/proptype-validation';
import { viewTypes } from '../../../constants/view-types';

export class PureIssuePreviewCallToAction extends PureComponent {

  constructor(props) {
    super(props);

    this.handleActionSelect = this.handleActionSelect.bind(this);
  }

  handleActionSelect(actionId, action) {
    this.props.onStatusChange(action);
  }

  render() {
    const { issue, viewType } = this.props;
    const options = getCallToActionOptions(issue);

    if (!options.length) {
      return null;
    }

    const isNarrow = viewType === viewTypes.DOCUMENT;
    const isWide = !isNarrow;
    const classes = classNames('IssuePreviewCallToAction', {
      'IssuePreviewCallToAction--narrow': isNarrow,
      'IssuePreviewCallToAction--wide': isWide,
    });
    return (
      <div className={classes}>
        <div className="IssuePreviewCallToAction__button-wrapper" data-testid="IssuePreviewCallToAction__button-wrapper">
          {isWide &&
            <div className="IssuePreviewCallToAction__text">
              {T.translate('callToAction.actionRequired')}
            </div>
          }
          <ButtonGroup
            options={options}
            onSelect={this.handleActionSelect}
            isSaving={false}
            savingText={options[0].label}
          />
        </div>
      </div>
    );
  }
}

PureIssuePreviewCallToAction.displayName = 'IssuePreviewCallToAction';

PureIssuePreviewCallToAction.propTypes = {
  issue: issueAttributesType,
  onStatusChange: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  issue: getCurrentPreviewIssueAttributes(state),
  viewType: getCurrentViewType(state),
});

export default connect(mapStateToProps)(PureIssuePreviewCallToAction);
